import React from 'react'
import { Modal } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { i18nTranslate, trackGTMEvents } from 'src/utils'
import './styles.scss'

/**
 * FreeGiftsModal component renders a modal
 * with gifts details.
 *
 * Props:
 * - show: Boolean to show/hide modal
 * - onHide: Callback to hide modal
 * - subscriptions: Object with subscriptions data
 */
@observer
class OrderNowModal extends React.Component {
  handleProcessNow = () => {
    // call process order API
    const { handleProcessingNow, ProcessDate, onHide } = this.props
    if (ProcessDate && handleProcessingNow) {
      handleProcessingNow(ProcessDate)
    }

    onHide()
  }
  trackSubscriptionOrderNowCancelEvent = () => {
    const { subscriptionResponse = [] } = this.props
    const subscriptionsArray = subscriptionResponse?.[0]?.subscriptions || []
    let productDetailsArr = []
    if (subscriptionsArray.length > 0) {
      subscriptionsArray.map(item => {
        productDetailsArr.push({
          name: item?.itemInfo?.[0]?.properties?.name || '',
          id: item?.id || '',
          price: item?.itemInfo?.[0]?.totalValue?.priceAfterDiscount || 0,
        })
      })
    }
    trackGTMEvents({
      event: 'subscriptionOrderNowCancel',
      products: productDetailsArr,
      type: 'next orders',
    })
  }
  render() {
    const { itemsPriceTotal, cardNumber } = this.props

    return (
      <Modal
        {...this.props}
        centered
        className="order-modal-container"
        data-testid="qa-subscription-order-now-container">
        <Modal.Header closeButton>
          <Modal.Title className="order-modal-title">
            {i18nTranslate('subscription.orderNowButton', 'Order now')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="order-modal-description d-flex">
            <div
              className="order-modal-description-l1"
              data-testid="qa-sub-ordernow-details">
              {i18nTranslate(
                'subscription.orderNowDetails',
                'Clicking Submit order will process this month’s subscription items. Submitting your order now will not change your regularly scheduled processing date for future orders.'
              )}
            </div>
            <div className="order-modal-description-l2">
              <span
                className="order-total d-flex"
                data-testid="qa-sub-ordernow-total-value">
                {i18nTranslate('cart.orderTotal', 'Order Total')}:{' '}
                {itemsPriceTotal}
              </span>
              <span
                className="order-amount d-flex pb-2"
                data-testid="qa-sub-ordernow-total-text">
                {i18nTranslate(
                  'subscription.orderNowCardDetail',
                  'Amount to be charged to credit card ending in'
                )}{' '}
                {cardNumber}
              </span>
            </div>
          </div>
          <button
            className="order-modal-button-continue"
            data-testid="qa-sub-ordernow-submit"
            onClick={() => this.handleProcessNow()}>
            {i18nTranslate('review.submitOrder', 'Submit order')}
          </button>
          <button
            className="order-modal-button-back"
            data-testid="qa-sub-ordernow-cancel"
            onClick={() => {
              this.trackSubscriptionOrderNowCancelEvent()
              this.props.onHide()
            }}>
            {i18nTranslate('subscription.orderNowCancel', 'Cancel')}
          </button>
        </Modal.Body>
      </Modal>
    )
  }
}

export { OrderNowModal }
export default OrderNowModal
